import React, { useMemo } from 'react';
import { IClientBusinessModel } from '../../../Types/ClientModelTypes';
import StandardRutinMaster from '../../Delsystem/_StandardRutin/StandardRutinMaster';
import { IMasterConfig, IDetailConfig } from '../../../Types/MasterDetailTypes';
import { MdModalRoute } from '../../../Components/MasterDetail/Components/MdModal/MdModalRoute';
import { DebugViewDetail } from './DebugViewDetail/DebugViewDetail';
import businessCollectionComponents from '../../Delsystem/_Common/Components/BusinessCollectionComponents/businessCollectionComponents';

interface IProps {
  rutinKod: string;
  collection: IClientBusinessModel;
  detaljVy?: string;
}

const createMasterConfig = (
  collection: IClientBusinessModel,
  // Temp until implementation is decided upon
  rutinKod: string,
  showCheckboxes?: boolean
): IMasterConfig => ({
  comp: StandardRutinMaster(collection, rutinKod, showCheckboxes),
  caption: 'Innehåll',
});

const createDetailConfig = (
  collection: IClientBusinessModel,
  detaljvy?: string
): IDetailConfig => ({
  comp: (businessCollectionComponents(collection.CollectionName)
    .find(vy => vy.id === detaljvy)
    ?.def(collection).comp ??
    DebugViewDetail(collection)) as IDetailConfig['comp'],
  caption: 'Detaljer',
});

const DebugView: React.FC<React.PropsWithChildren<IProps>> = props => {
  const Master = useMemo(
    () => createMasterConfig(props.collection, props.rutinKod, false),
    [props.collection, props.rutinKod]
  );
  const Detail = useMemo(
    () => createDetailConfig(props.collection, props.detaljVy),
    [props.collection, props.detaljVy]
  );

  return (
    <MdModalRoute
      master={Master}
      detail={Detail}
      collection={props.collection}
    />
  );
};

export default DebugView;
